import type { ErrorBoundaryProps } from '@epihub/web/src/components/ErrorBoundary';
import { ErrorBoundaryView } from './ErrorBoundaryView';

// These error boundary props are used at the very root of the app
// meaning we don't have access to anything except basic html
// - Mantine components would crash because the provider is missing
// - Tailwind styling wouldn't work because the provider is missing
// As a result, instead of rendering something we redirect to the error page
export const rootErrorBoundaryProps = {
  fallbackRender: () => {
    window.location.href = '/error';
    return null;
  },
} satisfies ErrorBoundaryProps;

type FallbackRendererProps = {
  error?: any;
  resetErrorBoundary?: () => void;
};

export const ErrorBoundaryFallback = ({ error, resetErrorBoundary }: FallbackRendererProps) => (
  <ErrorBoundaryView
    error={error}
    resetErrorBoundary={resetErrorBoundary}
  />
);
